var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteCheckMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48629_769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6477 0.464111H1.46021C0.942236 0.464111 0.522705 0.883643 0.522705 1.40161V13.5891C0.522705 14.1071 0.942236 14.5266 1.46021 14.5266H13.6477C14.1657 14.5266 14.5852 14.1071 14.5852 13.5891V1.40161C14.5852 0.883643 14.1657 0.464111 13.6477 0.464111Z",
    fill: "#689F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9094 0.464111H1.40161C0.91763 0.467627 0.526223 0.859033 0.522708 1.34302V12.8157C0.521536 13.3008 0.914114 13.6934 1.39927 13.6946C1.40044 13.6946 1.40044 13.6946 1.40161 13.6946H12.8977C13.3829 13.6958 13.7754 13.3032 13.7766 12.818C13.7766 12.8168 13.7766 12.8168 13.7766 12.8157V1.34302C13.7872 0.868408 13.4098 0.474658 12.9352 0.464111C12.927 0.464111 12.9176 0.464111 12.9094 0.464111Z",
    fill: "#7CB342"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M4.7063 1.5072C4.7063 1.23767 4.5188 1.15564 3.44067 1.19079C2.53833 1.22595 2.09302 1.33142 1.82349 1.65954C1.55396 1.98767 1.48364 2.65564 1.47192 3.45251C1.47192 4.01501 1.47192 4.54236 1.76489 4.54236C2.16333 4.54236 2.16333 3.61657 2.49146 3.10095C3.12427 2.08142 4.7063 1.85876 4.7063 1.5072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.06953 12.8275C4.60547 12.8404 4.18946 12.5439 4.05 12.1009L2.28047 6.76891C2.10938 6.20524 2.42813 5.60876 2.9918 5.43766C3.53672 5.27243 4.11563 5.56422 4.30781 6.10094L5.45625 9.55797L10.9758 2.5736C11.3414 2.11071 12.0129 2.03219 12.4758 2.39782C12.9387 2.76344 13.0172 3.43493 12.6516 3.89782L5.90156 12.4173C5.70117 12.674 5.39531 12.8252 5.06953 12.8275Z",
    fill: "#FBF9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48629_769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheckMark);
export default __webpack_public_path__ + "static/media/white_check_mark.a02c976a4a8b5ee41c48e9834d7487a4.svg";
export { ForwardRef as ReactComponent };